import { createQueryKeys } from "../../shared/utils/create-query-keys";

export const phonebookKeys = createQueryKeys("phonebook", {
  list: null,
  search: (searchTerm: string) => ({ searchTerm }),
});
